import { render, staticRenderFns } from "./MostSales.vue?vue&type=template&id=4d1d7aaa"
import script from "./MostSales.vue?vue&type=script&lang=js"
export * from "./MostSales.vue?vue&type=script&lang=js"
import style0 from "./MostSales.vue?vue&type=style&index=0&id=4d1d7aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports